import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
  activateListingDisableDevtool,
  handleConfirmedInspectionAttempt,
  isListingDetailPath,
  suspendListingDisableDevtool,
} from './listingDisableDevtool.js';
import { startListingDevtoolDockMonitor } from './listingDevtoolDockDetector.js';

const INSPECTION_SHORTCUT_KEYS = ['I', 'J', 'C', 'K'];
const EDITABLE_ELEMENT_NAMES = ['INPUT', 'TEXTAREA', 'SELECT'];

const isEditableTarget = target => {
  const tagName = target?.tagName?.toUpperCase();
  const isEditableElement = EDITABLE_ELEMENT_NAMES.includes(tagName);
  const isContentEditable =
    target?.isContentEditable === true || target?.closest?.('[contenteditable="true"]') != null;

  return isEditableElement || isContentEditable;
};

export const handleListingPageContextMenu = event => {
  event.preventDefault();
};

export const handleListingPageKeyDown = event => {
  if (isEditableTarget(event.target)) {
    return false;
  }

  const key = event.key?.toUpperCase();
  const isFunctionKeyShortcut = key === 'F12';
  const isWindowsOrLinuxInspectionShortcut =
    event.ctrlKey && event.shiftKey && INSPECTION_SHORTCUT_KEYS.includes(key);
  const isAppleInspectionShortcut =
    event.metaKey && event.altKey && INSPECTION_SHORTCUT_KEYS.includes(key);
  const isViewSourceShortcut = (event.ctrlKey || event.metaKey) && !event.shiftKey && key === 'U';

  if (
    isFunctionKeyShortcut ||
    isWindowsOrLinuxInspectionShortcut ||
    isAppleInspectionShortcut ||
    isViewSourceShortcut
  ) {
    event.preventDefault();
    return true;
  }

  return false;
};

const useListingInspectionDeterrent = () => {
  const history = useHistory();
  const location = useLocation();
  const shouldProtectRoute = isListingDetailPath(location.pathname);

  useEffect(() => {
    if (!shouldProtectRoute) {
      suspendListingDisableDevtool();
      return undefined;
    }

    const handleKeyDown = event => {
      if (handleListingPageKeyDown(event)) {
        handleConfirmedInspectionAttempt();
      }
    };

    activateListingDisableDevtool(path => history.replace(path));
    const stopDockMonitor = startListingDevtoolDockMonitor({
      onConfirmed: handleConfirmedInspectionAttempt,
    });
    document.addEventListener('contextmenu', handleListingPageContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      stopDockMonitor();
      suspendListingDisableDevtool();
      document.removeEventListener('contextmenu', handleListingPageContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [history, shouldProtectRoute]);
};

export default useListingInspectionDeterrent;
